import { render } from "./TraitRanksApesTraitsFiltersSearch.vue?vue&type=template&id=cb1f0b5a"
import script from "./TraitRanksApesTraitsFiltersSearch.vue?vue&type=script&lang=js"
export * from "./TraitRanksApesTraitsFiltersSearch.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__